import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMinusSmall: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconMinusSmall"><Path d="M6.5 12H17.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconMinusSmall;
